module.exports = __webpack_public_path__ + "static/media/LightningIcon.d3766823.svg";